import { getCSRFToken, fetchCSRFToken } from "./csrf";

export async function logOut() {
  try {
    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

    const response = await fetch("/api/_allauth/browser/v1/auth/session", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
    });

    if (response.ok || response.status === 401) {
      return true;
    }

    return false;
  } catch (error) {
    console.error("Logout error:", error);
    return false;
  }
}
